import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { UI_COLORS } from '../../utils/colors';
import DataTable from '../common/DataTable';
import { useTranslation } from 'react-i18next';

const formatDate = (dateString) => {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const VehicleTrackingTable = ({ items, onView, loading = false }) => {
  const { t } = useTranslation();
  const columns = useMemo(() => [
    {
      id: 'order_number',
      label: t('vehicleTracking.columns.orderId'),
      sortable: true,
      renderCell: (o) => (
        <div className="text-sm font-medium" style={{ color: UI_COLORS.TEXT.PRIMARY }}>
          #{o.order_number || o.order_id}
        </div>
      ),
    },
    {
      id: 'sub_order_number',
      label: t('vehicleTracking.columns.subOrderId'),
      sortable: true,
      renderCell: (o) => (
        <div className="text-sm" style={{ color: UI_COLORS.TEXT.SECONDARY }}>
          {o.sub_order_number || o.sub_order_id}
        </div>
      ),
    },
    {
      id: 'vehicle_number',
      label: t('vehicleTracking.columns.vehicleNumber'),
      sortable: true,
      renderCell: (o) => (
        <div className="flex items-center gap-2">
          <div 
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: UI_COLORS.BRAND.PRIMARY }}
          ></div>
          <span className="text-sm font-medium text-gray-800 uppercase">{o.vehicle_number}</span>
        </div>
      ),
    },
    {
      id: 'supervisor_name',
      label: t('vehicleTracking.columns.supervisorName'),
      sortable: true,
      renderCell: (o) => (
        <div className="text-sm" style={{ color: UI_COLORS.TEXT.PRIMARY }}>
          {o.supervisor_name || t('vehicleTracking.values.notAssigned')}
        </div>
      ),
    },
    {
      id: 'location_name',
      label: t('vehicleTracking.columns.location'),
      sortable: true,
      renderCell: (o) => (
        <div className="text-sm truncate max-w-[200px]" style={{ color: UI_COLORS.TEXT.SECONDARY }} title={o.location_name}>
          {o.location_name}
        </div>
      ),
    },
    {
      id: 'order_date',
      label: t('vehicleTracking.columns.orderDate'),
      sortable: true,
      renderCell: (o) => (
        <div className="text-sm" style={{ color: UI_COLORS.TEXT.SECONDARY }}>
          {formatDate(o.order_date)}
        </div>
      ),
    },
    {
      id: 'actions',
      label: t('common.table.actions'),
      textAlign: 'center',
      renderCell: (o) => (
        <div className="flex justify-center">
          <button
            onClick={() => onView(o)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all hover:scale-105 active:scale-95"
            style={{ 
              backgroundColor: 'rgba(0, 102, 204, 0.1)',
              color: '#0066cc'
            }}
          >
            <FontAwesomeIcon icon={faEye} />
            {t('common.actions.view')}
          </button>
        </div>
      ),
    },
  ], [onView, t]);

  return (
    <DataTable
      columns={columns}
      data={items}
      loading={loading}
      enablePagination={false}
      emptyMessage={t('vehicleTracking.emptyMessage')}
    />
  );
};

export default VehicleTrackingTable;
